<!--
 * @Author: chenjianxiong 2232943862@qq.com
 * @Date: 2025-09-30 09:12:51
 * @LastEditors: chenjianxiong 2232943862@qq.com
 * @LastEditTime: 2025-10-24 09:20:47
 * @FilePath: \itos-front-ysedu="\src\views\web\text.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>

    <div class="preferred-assets">
      <el-image
        class="carousel-image"
        preview-teleported
        close-on-press-escape
        hide-on-click-modal
        :zoom-rate="1.2"
        :preview-src-list="[url]"
        :src="url"
        fit="cover"
        @show="closePreferredInterval"
        @close="setPreferredInterval"
      >
       <template #error>
        <div class="image-slot">
          <el-empty description=""/>
        </div>
      </template>
      <template #placeholder>
        <div class="image-slot">
          <div v-loading="true">
          </div>
        </div>
      </template>
      </el-image>
      <div class="assets-info">
        <div class="content-title">
          <div class="tabItem active">
            优选资产
          </div>
          <div class="content-titles-more" @click="routclick('mycurrentaffairs')">
            更多
            <el-icon>
              <ArrowRight />
            </el-icon>
          </div>
        </div>

        <el-skeleton v-if="loading" :loading="loading" animated>
          <template #template>
            <el-skeleton class="mt20" :rows="6" animated style="margin-top: 20px;" />
          </template>
        </el-skeleton>
        <div v-else-if="assetsList.length" class="list-content">
          <div
           @click="routePush(asset.newsIds)"
            v-for="(asset, index) in assetsList"
            :key="asset.newsIds"
            class="asset-item"
            :class="{ active: index === activeIndex }"
          >
            {{ asset.title }}
          </div>
        </div>
        <div v-else style="height: 100%">
          <el-empty style="padding: 8px 0px" description="暂无资源" />
        </div>
      </div>
    </div>

</template>

<script setup>
  import { reactive, ref,computed,onMounted,onUnmounted  } from 'vue';
  import { ArrowRight,Picture as IconPicture } from '@element-plus/icons-vue';
  import {getPreferredAssetApi} from '@/api/home'
  import { useRouter } from "vue-router"; //引入路由
  const router = useRouter()
  // const route = useRoute();
  const loading = ref(false);
  const assetsList = reactive([]);
  const activeIndex = ref(0);
  const scrollPreferredInterval = ref();
  const url = computed(() => {
    return assetsList[activeIndex.value]?.url;
  });
  const closePreferredInterval = () => {
    clearInterval(scrollPreferredInterval.value);
    scrollPreferredInterval.value = null;
  };
  const setPreferredInterval = () => {
    console.log('setPreferredInterval');
    scrollPreferredInterval.value = setInterval(() => {
      if (activeIndex.value < 4) {
        activeIndex.value = activeIndex.value + 1;
      } else {
        activeIndex.value = 0;
      }
    }, 5000);
  };
  const routclick = (res) => {
  let url = router.resolve(`/${res}`);
  window.open(url.href);
};
//首页时事新闻跳转详情
const routePush = (item) => {
  let url = router.resolve({
    path: "/Newsdetail",
    query: { id: item },
  });
  window.open(url.href);
};
  onMounted(async() => {
    try {
        loading.value = true;
        const res = await getPreferredAssetApi()
        console.log(res.data)
        assetsList.splice(0,assetsList.length,...res.data) 
        loading.value = false;
        assetsList.length > 1 && setPreferredInterval();
    } catch (error) {
      loading.value = false;
    }
  });
  onUnmounted(() => {
  closePreferredInterval()
  });
</script>

<style lang="scss">
.preferred-assets {
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: white;
  padding: 10px;
  height: 370px;
  box-sizing: border-box;

.carousel-image {
  width: 632px;
  height: 359px;
  flex-shrink: 0;
  margin-right: 50px;
}
.image-slot{
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-title {
  display: flex;
  position: relative;
  margin-bottom: 24px;
}

.content-titles-more {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #888888;
  position: absolute;
  right: 0;
  top: 12px;
  cursor: pointer;
}

.tabItem {
  height: 50px;
  width: 114px;
  line-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

}

.icon {
  position: absolute;
  right: -22px;
  font-size: 18px;
}

.tabItem.active {
  border-bottom: 3px solid #c08c58;
  color: #c08c58;
  height: 53px;
  font-size: 18px;
  font-weight: bold;
}

.assets-info {
  flex: 1;
  padding-right: 10px;
  overflow: hidden;
}

.list-content .asset-item {
  margin-bottom: 22px;
  font-weight: 500;
  font-size: 20px;
  color: #323233;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 1; 
  cursor: pointer;
}

.list-content .asset-item.active {
  font-weight: bold;
}
}

</style>
